<template>
	<div class="margin-left">
		<div class="flex align-center topall bg-white">
			<p @click="chose(item.id)" class="flex-sub text-center pointer" :class="topindex == item.id?'active text-theme':''" v-for="(item,index) in top" :key="index">{{item.name}}</p>
			
		</div>
		<div v-if="total != 0">
			<el-row :gutter="20">
				<el-col :span="12" v-for="(item,index) in listData" :key="index"><InvoiceList :data="item" @godetail="godetail()"></InvoiceList></el-col>
			</el-row>
			<div class="pagination">
				<el-pagination
				  background
				  layout="prev, pager, next"
				  prev-text="上一页"
				  next-text="下一页"
				  :total="50">
				</el-pagination>
			</div>
		</div>
		<div class="flex flex-direction align-center justify-center" v-else>
			<img class="nobill" src="../../../assets/img/nobill.png" >
			<div class="invoice text-white">去开票</div>
		</div>
	</div>
</template>

<script>
	import InvoiceList from '../../list/invoice-list.vue';
	export default {
		components: {
			InvoiceList,
		},
		data() {
			return {
				top:[
					{
						name:'全部',
						id:4
					},{
						name:'待审核',
						id:1
					},{
						name:'已开票',
						id:2
					},{
						name:'已驳回',
						id:3
					}
				],//状态
				topindex:4,//选中的状态下表
				listData:[],
				page:1,
				total:0,//
			};
		},
		created() {
			this.getInvoicelist()
		},
		methods: {
			//选中状态
			chose(index){
				this.topindex = index
			},
			//通知center 跳转对应页面
			godetail(){
				let type = {
					type:'detailt',
					typeone:'recordt'
				}
				this.$emit('gettype',type)
			},
			handleCurrentChange: function(currentPage) {
			  this.page = currentPage;
			  this.getInvoicelist();
			},
			//获取任务积分
			getInvoicelist(){
				this.ajax('get', '/api/invoice/getInvoicelist', {
					status:this.topindex,
					type:3,
					page:this.page
				},res => {
					console.log(res.data);
					this.listData = res.data.data
					if(this.page == 1){
						this.total =  Number(res.data.lastpage) * Number(res.data.data.length)
					}
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.topall{
		width: 921px;
		height: 69px;
		box-shadow: -4px 3px 19px 1px rgba(204,204,204,0.2000);
		border-radius: 10px;
		p{
			height: 69px;
			line-height: 69px;
		}
	}
	.nobill{
		width: 180px;
		height: 139px;
		margin-top: 100px;
		margin-bottom: 32px;
		font-size: 22px;
	}
	.invoice{
		width: 165px;
		height: 50px;
		line-height: 50px;
		background: #09827B;
		box-shadow: 3px 4px 19px 1px rgba(10,114,108,0.2000);
		border-radius: 25px;
	}
	/deep/ .el-pagination.is-background .btn-next,/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .el-pager li{
		background: #fff !important;
	}
	/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
		background:#09827B !important;
		color: #fff !important;
	}
	/deep/ .el-pagination.is-background .btn-prev,/deep/ .el-pagination.is-background .btn-next{
		padding: 0 10px;
	}
	
	.pagination{
		margin: 59px 0;
	}
	.active{
		
		position: relative;
		&:after{
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 27px;
			height: 6px;
			background: #0B837C;
			border-radius: 3px;
			content: '';
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/receipt/record.vue